import React, { useEffect } from 'react';
import Background from 'components/Background';
import WelcomeBackground from 'images/characters/welcome-characters-background.svg';
import {
  createLinkAccountModalOptions,
  createLinkAccountDoneModalOptions,
  createLinkAccountJiraDoneModalOptions,
  createLinkAccountGitProviderDoneModalOptions
} from 'modals/modal-options-factory';
import * as TrackingService from 'common/services/tracking.service';
import _ from 'lodash';
import {
  AUTH_FLOWS,
  AUTH_LEVEL,
  PROVIDERS_MAP,
  TRACKING
} from 'common/constants/constants';
import { linkAccount } from 'modals/AuthModals/auth.modals.service';
import QueryString from 'qs';

import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { toggleModal } from 'state/callers';
import { getProviderDetailsLinkAccount } from 'common/utils/provider.utils';

const styles = {
  background: `url(${WelcomeBackground}) no-repeat bottom right 7rem`,
  backgroundSize: `30rem`
};

const getLinkAccountDoneModalOptions = errorType => {
  const LINK_ACCOUNT_ERRORS_TO_PROPS = {
    MULTIPLE_ORGS_CONTRIBUTOR: { isMultipleOrgsContrib: true },
    UNMATCH_CONTRIBUTOR: { isContributor: false }
  };

  return LINK_ACCOUNT_ERRORS_TO_PROPS[errorType];
};

const OAuthLinkAccount = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const error = _.get(location, 'state.error', null);
  const canLogin = _.get(location, 'state.canLogin', null);
  const accountId = _.get(location, 'state.accountId', null);
  const search = QueryString.parse(_.get(location, 'search'), {
    ignoreQueryPrefix: true
  });
  const direct = _.get(search, 'direct', 'false') === 'true';
  const providerName =
    _.get(search, 'providerName') || _.get(location, 'state.providerName', '');
  const authFlow = _.get(location, 'state.authFlow');
  const authLevel = _.get(location, 'state.authLevel', AUTH_LEVEL.ORGANIZATION);
  const isIdentity = providerName.includes('_identity');

  const isJiraOauth2FromSlack =
    authFlow === AUTH_FLOWS.LINK_ACCOUNT &&
    providerName.toLowerCase() === PROVIDERS_MAP.jira.name.toLowerCase();

  const providerDetails = getProviderDetailsLinkAccount(
    authFlow,
    authLevel,
    providerName,
    false
  );
  useEffect(() => {
    TrackingService.logEvent(TRACKING.EVENTS.INVITATION_LINK_CLICKED);
    if (direct && providerName) {
      linkAccount(providerName, !isIdentity);
      return;
    }

    if (error || !_.isNull(canLogin)) {
      const createModalOptions = isJiraOauth2FromSlack
        ? createLinkAccountJiraDoneModalOptions
        : providerDetails.hasOwnProperty('name')
        ? createLinkAccountGitProviderDoneModalOptions
        : createLinkAccountDoneModalOptions;

      dispatch(
        toggleModal(
          createModalOptions({
            toggleModal: () => dispatch(toggleModal()),
            hasAccount: canLogin,
            isContributor: !_.isNull(canLogin),
            ...(error ? getLinkAccountDoneModalOptions(error.type) : {}),
            accountId,
            ...providerDetails
          })
        )
      );
      return;
    }

    dispatch(toggleModal(createLinkAccountModalOptions()));
  }, []);
  return <Background styles={styles} />;
};
export default OAuthLinkAccount;
